export default "__VITE_ASSET__BNnsaHYG__"